module.exports = __webpack_public_path__ + "media/images/light_gray_lines_horizontal-42041fad062dd97a13ca2a43c8c5d6eb.svg";